// extracted by mini-css-extract-plugin
module.exports = {"bottomGrid":"SolutionsExpandedContent_bottomGrid__2Jz8s"};